// IMPORTANT: This file is copied from the instant-gae-app repository.
// Any changes should be made there and then copied here.

const hasSequential = str => {
	for (let i = 0; i < str.length - 3; i++) {
		const current = str.charCodeAt(i);
		const next1 = str.charCodeAt(i + 1);
		const next2 = str.charCodeAt(i + 2);
		const next3 = str.charCodeAt(i + 3);
		// Check ascending sequence
		if (next1 === current + 1 && next2 === current + 2 && next3 === current + 3) return true;
		// Check descending sequence
		if (next1 === current - 1 && next2 === current - 2 && next3 === current - 3) return true;
	}
	return false;
};

const RULES = [
	{
		id: "minLength",
		check: (password, min_password_length) => password.length >= min_password_length,
		hint: min_password_length => `At least ${min_password_length} characters`,
	},
	{
		id: "hasLettersAndNumber",
		check: password => /[a-zA-Z]/.test(password) && /\d/.test(password),
		hint: "Contains both letters and numbers",
	},
	{
		id: "noRepeats",
		check: password => !/(.)\1{3,}/.test(password),
		hint: "No repeating characters (e.g. AAAA)",
	},
	{
		id: "noSequential",
		check: password => !hasSequential(password),
		hint: "No sequential patterns (e.g. 123, abc, cba, 321)",
	},
	{
		id: "noSamePassword",
		check: () => null,
		hint: "Cannot be the same as the previous 5 passwords",
	},
];

export function checkPassword(password, min_password_length = 8) {
	return RULES.map(rule => ({
		id: rule.id,
		pass: rule.check(password, min_password_length),
		hint: typeof rule.hint === "function" ? rule.hint(min_password_length) : rule.hint,
	}));
}

export function isValidPassword(password, min_password_length = 8) {
	return RULES.every(rule => [true, null].includes(rule.check(password, min_password_length)));
}
